module.exports = __webpack_public_path__ + "static/media/grin-squint.b944e676.svg";